import { useQueryClient } from 'react-query';
import { LocalStorageKeys } from '../../../../constants/local-storage-keys';
import { useCreatePlan } from '../../../../hooks/requests/use-create-plan';
import { useVyNavigate } from '../../../../hooks/use-vy-navigate';
import { parsePlanInput } from '../../../../utils/parse-plan-input';
import { runDebouncedMutation } from '../../../../utils/vy-mutation';
import { CREATE_PLAN_MUTATION_KEY } from '../create-plan-page-consts/create-plan-mutation-key';
import { PlanInputForm } from '../create-plan-page-components/CreatePlanForm/create-plan-form-types/plan-input-form';
import { useCallback } from 'react';

export const usePlanSubmitter = () => {
  const navigate = useVyNavigate();
  const queryClient = useQueryClient();
  const createPlanMutation = useCreatePlan();

  return useCallback(
    async (planInput: PlanInputForm) => {
      const parsedPlanResult = parsePlanInput(planInput, {
        errorContext: 'Update plan validation',
      });

      if (!parsedPlanResult.success) {
        return;
      }

      const parsedPlan = parsedPlanResult.data;

      await runDebouncedMutation(
        `create-plan`,
        createPlanMutation,
        parsedPlan,
        {
          pending: 'Creating plan...',
          success: 'Plan created',
          error: 'Failed to create plan',
        },
        {
          mutationKey: CREATE_PLAN_MUTATION_KEY,
          onSuccess: async ({ plan: savedPlan }) => {
            await queryClient.resetQueries(['contractPage']);
            await queryClient.resetQueries(['plan-overview']);

            localStorage.removeItem(LocalStorageKeys.CreatePlan);
            navigate(`/plans/${savedPlan.id}`);
          },
        },
      );
    },
    [createPlanMutation, navigate, queryClient],
  );
};
